export const nameof = <T>(name: keyof T) => name

export function formatCurrency(amount: number, currency = 'SEK') {
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency,
  }

  if (currency !== 'EUR') {
    options.minimumFractionDigits = 0
  }

  return new Intl.NumberFormat('sv-SE', options).format(amount)
}



// WEBPACK FOOTER //
// ./src/utils.ts